import React, { Component } from 'react';
import { connect } from 'react-redux';

import LANGUAGE_CONTROLLER from '../../controllers/languages';
import { SSelect } from "@avalara/skylab-sdk/react";
import Logger, { LOG_LEVELS } from '../../utils/log';
const log = new Logger('DATA_MINING_COMMON_FILTER_PANEL', LOG_LEVELS.DEBUG);

export class DataMiningCommonFilterPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selection: {
                reportType: props.reportType || ''
            }
        };
        this.onReportTypeChangeHandler = this.onReportTypeChangeHandler.bind(this);
    }

    onReportTypeChangeHandler(evt) {
        log.debug('onReportTypeChangeHandler() Value', evt.detail.item.value);
        let selection = Object.assign({}, this.state.selection);
        selection.reportType = evt.detail.item.value;
        this.setState({ selection: selection });
        if (typeof this.props.onReportTypeChange === 'function') {
            this.props.onReportTypeChange(selection);
        }
    }

    getReturnTypeOptions() {
        const reportTypes = ["dataMining_InvoiceLines", "dataMining_IntrastatLines", "dataMining_ChangesLogLines",
                            "dataMining_DeleteLog", "dataMining_ReportingCombinationsHistory", "dataMining_GLStatusOverviewVRSide", "dataMining_GLStatusOverviewGLSide",
                            "dataMining_ProcessingLog", "dataMining_SiiTransactions", "dataMining_SIILog", "MTDLiability", "MTDPayments", "MTDObligations"];
        let reportTypeOptionsList = [{
            label: LANGUAGE_CONTROLLER.format(this.props.languages, "dataMining_SelectReportType"),
            value: "",
            selected: !this.state.selection.reportType? true: false
        }];
        reportTypes.forEach((val) => {
            let intlVal = LANGUAGE_CONTROLLER.format(this.props.languages, val);
            reportTypeOptionsList.push({
                label: intlVal,
                value: intlVal,
                selected: this.state.selection.reportType === intlVal? true: false
            });
        });
        return reportTypeOptionsList;
    }

    render() {
        log.debug('render() - props: ', this.props);

        return (
            <div data-test="component-data-mining-common-filter-panel">
                <fieldset>
                    <label className="mr20"><span>{LANGUAGE_CONTROLLER.format(this.props.languages, 'dataMining_ReportType')}</span></label>
                    <SSelect defaultValue={this.state.selection.reportType} 
                        inputId="single-reportType-select"
                        name="reporttype"
                        onS-select={this.onReportTypeChangeHandler.bind(this)}
                        optionsList={this.getReturnTypeOptions() || []}
                        multiple={false}
                        showSelectionCount={false}
                    />
                </fieldset>
            </div>
        );
    }
}


DataMiningCommonFilterPanel.defaultProps = {
    onReportTypeChange: () => { }
}

function mapStateToProps(state) {
    return {
        languages: state.languages
    }
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(DataMiningCommonFilterPanel);